<template>
  <!-- -->
  <div class="user-profile" :style="{'--user-size': settingData.textSize, '--user-color': settingData.textColor, '--phone-size': settingData.phoneTextSize, '--phone-color': settingData.phoneColor, '--merchant-size': settingData.merchantTextSize, '--merchant-color': settingData.merchantColor, '--role-size': settingData.roleTextSize, '--role-color': settingData.roleColor, '--setting-btn-color': settingData.settingBtnColor}">
    <div class="user-icon">
      <img class="image" alt="" :src="getImageUrl(userInfo.iconUrl)" v-if="userInfo.iconUrl"/>
      <yq-icon v-else name="element-ui_s-custom"/>
    </div>
    <div class="user-info">
      <div class="user-name">
        <span>{{userInfo.employeeName}}</span>
        <span>{{userInfo.employeePhone}}</span>
      </div>
      <div class="user-role">
        <span>{{userInfo.merchantName}}</span>
        <span>{{userInfo.roleName}}</span>
      </div>
    </div>
    <yq-icon name="24gf-gear" class="setting"/>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";
import util from "@/util/util";
import ImageUtil from "@/util/imageUtil";
export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    YqIcon, AloneTextOnImage, AloneImage
  },
  data() {
    return {
      userInfo: {},
      settingData: [],
    };
  },
  created() {
    util.getUserInfo().then(res => {
      this.userInfo = res;
    });
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {
          textSize: "0.8533rem",
          textColor: "",
          phoneTextSize: "0.6333rem",
          phoneColor: "var(--yq-font-color-desc)",
          merchantTextSize: "0.6333rem",
          merchantColor: "",
          roleTextSize: "0.6333rem",
          roleColor: "var(--yq-font-color-desc)",
          settingBtnColor: "var(--yq-font-color-desc)",
        };
      } else {
        this.settingData = this.data.componentData;
      }
    },
    getImageUrl(url) {
      return ImageUtil.getFileUrlSingle(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  .user-icon{
    width: 150px;
    border-radius: 50%;
    background: var(--yq-background-color);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .image{
      width: 100%;
      aspect-ratio: 1/1;
      object-fit: contain;
    }
  }
  .user-info{
    flex: 1;
    margin: 0 20px;
    .user-name{
      :nth-child(1) {
        font-weight: 500;
        font-size: var(--user-size);
        color: var(--user-color);
      }
      :nth-child(2) {
        margin-left: 10px;
        color: var(--phone-color);
        font-size: var(--phone-size);
      }
    }
    .user-role{
      font-size: 24px;
      :nth-child(1) {
        color: var(--merchant-color);
        font-size: var(--merchant-size);
      }
      :nth-child(2) {
        color: var(--role-color);
        font-size: var(--role-size);
        margin-left: 20px;
      }
    }
  }
  .setting{
    color: var(--setting-btn-color);
  }
}
</style>